import { useState } from "react";

import * as Sentry from "@sentry/react";
import { Partner } from "@types-runway/state";

import { runwayApi } from "../../../api";

const useSearchPartner = () => {
  const [partner, setPartner] = useState<Partner | null>(null);

  const searchPartnerByPromocode = async (promocode: string): Promise<Partner[]> => {
    let searchResult: Partner[] = [];
    try {
      const { data } = await runwayApi.get(`/v1/partners/public-search?promocode=${promocode}`);
      setPartner(data[0]);
      searchResult = data;
    } catch (error) {
      Sentry.captureException(error, {
        tags: {
          location: "useSearchPartner",
          function: "searchPartnerByPromocode",
        },
      });
    } finally {
      return searchResult;
    }
  };

  return { searchPartnerByPromocode, partner };
};

export default useSearchPartner;
